export const PERMISSION_ADMIN = "com.mediamath.whitelabel.admin";
export const MAX_CAMPAIGN_DURATION_MONTHS = 36;
